import userService from "../../providers/userService";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";
import authService from "../../providers/authService";
import localStorageHelper from "../../helpers/local-storage-helper";
import Vue from "vue";

export const userInfoMixin = {
  data() {
    return {}
  },
  methods: {
    initCheckUserInfo() {
      setInterval(() => {
        if (authService.isAuthenticated()) {
          this.checkUserInfo();
        }
      }, Vue.prototype.$config.checkUserInfoPoolingTime);
    },
    async checkUserInfo() {
      userService.checkUserInfo(new URLSearchParams())
        .then(response => {
          if (response.userDisabled) {
            messagesNotifyHelper.errorNotify(
              this.$t('TOAST_NOTIFICATIONS').checkUserInfoTitle,
              this.$t('TOAST_NOTIFICATIONS').checkUserInfoMessage
              );
            authService.logout();
          }

          // if (response.userRights) {
          //   let hasUserUpdate = false;
          //   const rights = localStorageHelper.getCurrentUser().rights;
          //   let itemFinded = null;
          //   response.userRights.forEach(item => {
          //     itemFinded = rights.find(r => r.id == item.id);
          //     if (itemFinded) {
          //       if (itemFinded.nome != item.nome ||
          //         itemFinded.icone != item.icone ||
          //         itemFinded.habilitado != item.habilitado) {
          //         hasUserUpdate = true;
          //       }
          //     } else {
          //       hasUserUpdate = true;
          //       return;
          //     }
          //   });

          //   if (hasUserUpdate) {
          //     authService.updateUserRights(response.userRights, response.hasQuotesRights, true);
          //   }
          // }

          if (response.profile || response.signature || response.hasQuotesRights) {
            localStorageHelper.updateUserData(response);
          }
        })
        .catch(error => console.log(error))
    },
  }
};
